<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <div v-if="loading" class="text-center" style="width: 100%;height: 100vh;position:absolute; z-index:1;background-color: #ffffff6b;">
        <div style=" margin-top: 50%;margin-left: 10%; margin-right: 10%;">
          <img src="@/assets/images/ganImage/GanLoading.gif" alt="">
          <h4 >Por favor espere mientras creamos su perfil</h4>
        </div>
        
      </div>
      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-0 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-1 mx-auto"
        >
        <h2>Regístrese</h2>
          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-register-form mt-2"
            >
              <!-- username -->
              <b-form-group
                label="Nombres"
                label-for="register-firstName"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nombres"
                  vid="Nombres"
                  rules="required"
                >
                  <b-form-input
                    id="register-firstName"
                    v-model="firstName"
                    name="register-firstName"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Apellidos -->

               <b-form-group
                label="Apellidos"
                label-for="register-lastName"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Apellidos"
                  vid="lastName"
                  rules="required"
                >
                  <b-form-input
                    id="register-lastName"
                    v-model="lastName"
                    name="register-lastName"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- Cédula -->

              <b-form-group
                label="Tipo de identificación"
                label-for="TypeDoc"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de identificacion"
                  vid="typeid"
                  rules="required"
                >
                  <b-form-select
                    id="TypeDoc"
                    v-model="typeid"
                    :options="TypeDoc"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- Cédula -->

               <b-form-group
                :label="typeid"
                label-for="register-position"
                 v-if="showCedula"
                >
                <validation-provider
                  #default="{ errors }"
                  :name="poisitioN"
                  vid="poisitioN"
                  >
                  <b-form-input
                    id="register-position"
                    v-model="poisitioN"
                    v-mask="'#-####-####'"
                    name="register-position"
                    :state="errors.length > 0 ? false:null"
                    placeholder="_-____-____"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            
              <b-form-group
              :label="typeid"
              label-for="register-position2" 
              v-if="!showCedula"
             >
              <validation-provider
                #default="{ errors }"
                :name="poisitioN2"
                vid="poisitioN2"
                >

                <b-form-input 
                  id="register-position2"
                  v-model="poisitioN2"
                  name="register-position2"
                  :state="errors.length > 0 ? false:null"
                  v-mask='undefined'
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
              <!-- Teléfono -->

               <b-form-group
                label="Teléfono"
                label-for="register-telephone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Teléfono"
                  vid="Teléfono"
                  rules="required"
                >
                  <b-form-input
                    id="register-telephone"
                    v-model="telephone"
                    name="register-telephone"
                    v-mask="'(###)####-####'"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Correo -->

               <b-form-group
                label="Correo"
                label-for="register-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Correo"
                  vid="Correo"
                  rules="required|email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
            <b-form-group
              label="Contraseña"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                name="Contraseña"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="passWord"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="register-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
                
              </validation-provider>
            </b-form-group>


              <!-- CVO

               <b-form-group
                label="CVO"
                label-for="register-CVO"
              >
                <validation-provider
                  #default="{ errors }"
                  name="CVO"
                  vid="CVO"
                  rules="required"
                >
                  <b-form-input
                    id="register-CVO"
                    v-model="CVO"
                    name="register-CVO"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->

            <!-- Fecha de nacimiento -->
            <b-form-group class="datePicker">
                       
                          Fecha de nacimiento
                        <smooth-picker ref="smoothPicker" v-model="birthday" :data="data" :change="dataChange" class="form-control" />
              </b-form-group>


           <div class="d-flex justify-content-center align-items-center ">
            <b-form-checkbox v-model="terms">Acepto los <a href="https://www.corfoga.org/download/terminos-y-condiciones-de-uso-de-ganapp/" target="_blank">Términos y condiciones</a></b-form-checkbox>  
            <b-button @click="register"
                class="bg-primary"
                :disabled="!terms"
              >
              Registrarse
             <!-- <b-link :to="{name:'auth-register2', params:{firstName, lastName, birthday, telephone, position, email}}" class="toRegister2" >Siguiente</b-link> -->
              </b-button>
            </div>
            </b-form>
          </validation-observer>

         
        </b-col>
      </b-col>
    <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BButton,BFormSelect, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import flatPickr from 'vue-flatpickr-component'
import axios from 'axios'
import { mask } from 'vue-the-mask';

export default {
  directives: {mask},
  components: {
    flatPickr,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    const nowYear = (new Date()).getFullYear()
    const years = []
    for (let i = 1900; i <= nowYear; i++) {
      years.push(i)
    }
    return {
      showCedula:true,
      loading:false,
      firstName: '',
      lastName: '',
      birthday: '',
      telephone: '',
      poisitioN:'',
      poisitioN2:'',
      userEmail: '',
      passWord:'',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      TypeDoc:['Cédula','Cédula de residencia', 'Pasaporte'],
      typeid:'Cédula',
      terms:false,
      data:[
        {
            currentIndex: parseInt((nowYear - 1777) / 2),
            flex: 3,
            list: years,
            textAlign: 'center',
            className: 'row-group'
          },
          {
            currentIndex: 8,
            flex: 3,
            list: [...Array(12)].map((m, i) => i + 1),
            textAlign: 'center',
            className: 'row-group'
          },
          {
            currentIndex: 1,
            flex: 3,
            list: [...Array(30)].map((d, i) => i + 1),
            onClick: this.clickOnDay,
            textAlign: 'center',
            className: 'item-group'
          }
      ]
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    register() {
      let self= this;
      this.loading=true;
      let ciList = this.$refs.smoothPicker.getCurrentIndexList()
      let year = parseInt(this.data[0].list[ciList[0]]);
      let month = parseInt((this.data[1].list[ciList[1]])-1);
      let day = parseInt(this.data[2].list[ciList[2]]);
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      let bDay= new Date(year, month, day).toLocaleDateString('en-US', options);
      this.birthday= bDay;
      console.log(this.birthday)
      let cedula='';
      if(this.typeid=='Cédula'){
        cedula=this.poisitioN.replaceAll('-','')
      }else{
        cedula=this.poisitioN2
      }
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          axios.post(this.$apiUrl+'register',{
            names: this.firstName+' '+this.lastName,
            email: this.userEmail,
            password: this.passWord,
            poisition: cedula,
            phone:this.telephone,
            birthdate:this.birthday,
            level:2
          })
          .then(function() {
            self.loginfrm();
          })
          .catch(error => {
            console.log(error);
            this.$swal({
              title: 'Error',
              text: 'Usuario se encuentra registrado, intente con otro correo.',
              type: 'error',
              icon:'error',
              showCancelButton: false,
              confirmButtonColor:'#5E8F23',
              showCloseButton: true,
              showLoaderOnConfirm: false  
            })
          })
        }
      })
    },

    loginfrm(){
      axios.post(this.$apiUrl+'login',{
        username : this.userEmail,
        password: this.passWord,
      })
      .then(response => {
        let userData = response.data
        console.log("starting_point")
        useJwt.setToken(response.data.JWT)
        console.log(response.data);
        useJwt.setRefreshToken(response.data.JWT)
        localStorage.setItem('userData', JSON.stringify(userData.JWT))
        console.log(localStorage.getItem("accessToken"))
        this.$ability.update([{action: 'manage', subject: 'all'}])
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        axios.post(this.$apiUrl+'users/welcome',{
              email:this.userEmail
            },config);
        fetch(this.$apiUrl+"list/users?recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          console.log(result.users);
          result.users.forEach(UserRow => {
            if(UserRow.email==this.userEmail){
              localStorage.setItem('userMeta', JSON.stringify(UserRow));
              localStorage.setItem('userID', UserRow.id);
              
              this.loading=false;
              this.$router.replace('/')
              .then(() => {
                let userMeta= JSON.parse(localStorage.getItem('userMeta'));
                console.log(userMeta)
                let welcome= 'Bienvenido '+ userMeta.names+', te estábamos esperando.';
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-center',
                  props: {
                    title: welcome,
                    icon: 'StarIcon',
                    variant: 'success',
                  },
                })
              })
            }else{
              this.$router.replace('/');
            }
          });
        })
      })
      .catch(error => {
        console.log(error);
        this.loading=false;
        //this.$refs.loginForm.setErrors(error.response.data.error)
        this.$swal({
          title: 'Error',
          text: 'Usuario se encuentra registrado, intente con otro correo.',
          type: 'error',
          icon:'error',
          showCancelButton: false,
          confirmButtonColor:'#5E8F23',
          showCloseButton: true,
          showLoaderOnConfirm: false  
        })
      });
    },
    dataChange (gIndex, iIndex) {
        console.info('list', gIndex, iIndex)
        const ciList = this.$refs.smoothPicker.getCurrentIndexList()
        if (gIndex === 0 || gIndex === 1) { // year or month changed
          let currentIndex = 15
          let monthCount = 30
          let month = iIndex + 1 // month
          if (gIndex === 0) { // year
            month = this.data[1].list[ciList[1]]
          }
          switch (month) {
            case 2:
              let selectedYear = this.data[0].list[ciList[0]] // month
              if (gIndex === 0) { // year
                selectedYear = this.data[0].list[iIndex]
              }
              let isLeapYear = false
              if (this.isLeapYear(selectedYear)) {
                isLeapYear = true
              }
              monthCount = 28
              currentIndex = 14
              if (isLeapYear) {
                monthCount = 29
                currentIndex = 15
              }
              break
            case 4:
            case 6:
            case 9:
            case 11:
              monthCount = 30
              currentIndex = 15
              break
            default:
              monthCount = 31
              currentIndex = 16
          }
          const list = [...Array(monthCount)].map((d, i) => i + 1)
          this.$refs.smoothPicker.setGroupData(2, { ...this.data[2], ...{ currentIndex, list }})
        }
      },
      isLeapYear (year) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
      },
      clickOnDay (gIndex, iIndex) {
        window.alert('Clicked day: ' + this.data[gIndex].list[iIndex])
      },
      confirm () {
        const ciList = this.$refs.smoothPicker.getCurrentIndexList()
        const year = this.data[0].list[ciList[0]]
        const month = this.data[1].list[ciList[1]]
        const day = this.data[2].list[ciList[2]]
        window.alert(
          year + ' / ' + month + ' / ' + day
        )
      }
  },
  watch:{
      'typeid':function(value){
        if(value=='Cédula'){
          this.showCedula=true;
        }else{
          this.showCedula=false;
        }
        console.log(value);
      },

    },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>
